'use strict';

var angularModule = angular.module('t2g.common.data-access.billing', [
  'ngResource',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.sessionStorage').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = angularModule;

var STORAGE_KEY = 'billing';

angularModule.factory('BillingResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/billing/:subResource';

  var resource = $resource(
    resourceUrl,
    {},
    {
      subscribe: { method: 'PUT' },
      getSMSCredit: { method: 'GET', isArray: false, params: { subResource: 'smsCredit' } },
    },
  );

  return resource;
});

angularModule.factory('Billing', function(
  $q,
  $http,
  $rootScope,
  $timeout,
  localStorageService,
  BillingResource,
  ObjectModel,
  OfficeModel,
  OfficeDA,
  UserSession,
  settings,
) {
  return {
    purge: function() {
      var deferred = $q.defer();

      localStorageService.remove(STORAGE_KEY);

      $timeout(function() {
        deferred.resolve();
      }, 100);

      return deferred.promise;
    },
    get: function() {
      var deferred = $q.defer();

      if (localStorageService.get(STORAGE_KEY)) {
        deferred.resolve(localStorageService.get(STORAGE_KEY));
      } else {
        BillingResource.get({ officeId: UserSession.getOffice() }).$promise.then(
          function(response) {
            localStorageService.set(STORAGE_KEY, response);
            deferred.resolve(localStorageService.get(STORAGE_KEY));
          },
          function(error) {
            deferred.reject(error);
          },
        );
      }

      return deferred.promise;
    },
    subscribe: function(subscription) {
      var deferred = $q.defer();

      BillingResource.subscribe({ officeId: UserSession.getOffice() }, subscription).$promise.then(
        function(response) {
          localStorageService.set(STORAGE_KEY, response);
          deferred.resolve(localStorageService.get(STORAGE_KEY));
        },
        function(error) {
          deferred.reject(error);
        },
      );

      return deferred.promise;
    },
    calculate: function(callback) {
      ObjectModel.get(function(error, employees) {
        if (error) {
          callback(error);
        } else {
          OfficeDA.get()
            .then(function(office) {
              var services = 0;

              for (var i = 0, groupLen = office.serviceGroups.length; i < groupLen; i++) {
                if (!office.serviceGroups.intern) {
                  services += office.serviceGroups[i].services.length;
                }
              }

              var request = {
                url: settings.apiBase + '/api/v2/billing/calculatePrice',
                method: 'GET',
                params: {
                  employees: employees.length,
                  services: services,
                  currency: office.settings.currency,
                  office: office._id,
                },
              };

              $http(request)
                .then(function(data) {
                  data.employees = employees.length;
                  data.services = services;
                  callback(null, data);
                })
                .catch(function(data) {
                  callback(data);
                });
            })
            .catch(function(error) {
              callback(error);
            });
        }
      });
    },
    getPlan: function() {
      var deferred = $q.defer();

      if (localStorageService.get(STORAGE_KEY)) {
        deferred.resolve(localStorageService.get(STORAGE_KEY).plan);
      } else {
        this.get().then(
          function(billing) {
            deferred.resolve(billing.plan);
          },
          function(error) {
            deferred.reject(error);
          },
        );
      }

      return deferred.promise;
    },
    getSMSCredit: function() {
      return BillingResource.getSMSCredit({ officeId: UserSession.getOffice() }).$promise;
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/billing.js